import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <>
      <div className='footer-heading'>
        <h1>Students Special: Discounted Rates</h1>
        <h1>On Tropical Gateways</h1>
        <div className='foot-para'>
          <p>Let's embody your beautyful ideas togethor simply the
            Way you to visulise your big thig</p>
        </div>
      <div className='list-footer'>
        <ul>
          <li>Privacy Policy</li>
          <li>Terms of Use</li>
          <li>Sales and Refunds</li>
          <li>Legal</li>
        </ul>
        <ul>
          <li>About</li>
          <li>Schedules</li>
          <li>Pricing</li>
          <li>Membarship</li>
          <li>Joins</li>
        </ul>
      </div>
      </div>
    </>
  )
}

export default Footer